module.exports = __webpack_public_path__ + "img/def_malekith_0.6a07d4aa.png";